var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.successResult)?_c('div',{staticClass:"content-part content"},[(_vm.category && _vm.extraItem.extras('userCategory.text') == 'show')?_c('div',{staticClass:"t-success-new"},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"userCategory.content2"))+" : "+_vm._s(_vm.translatedCategory)+" ")]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras.successType.type == 'code'),expression:"extras.successType.type == 'code'"}],staticClass:"t-success",style:({
      border:
        _vm.extraItem.extras('qrcodeborderdisplay.display', 1) == 1
          ? '1px solid #e9e9e9'
          : '0px',
    })},[(_vm.extraItem.extras('qrcodedisplay.display', 1) == 1)?_c('div',{staticClass:"code-tip"},[_vm._v(" "+_vm._s(_vm.$t("success.credential"))+" ")]):_vm._e(),_c('div',{staticClass:"code-qrcode",class:_vm.platform,staticStyle:{"overflow":"hidden"},attrs:{"id":"signUpQrCode"}}),_c('div',{staticClass:"code-person"},[_vm._v(_vm._s(_vm.$t("success.attendeeId"))+"："+_vm._s(_vm.contactId))])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extras.successType.type == 'result'),expression:"extras.successType.type == 'result'"}],staticClass:"t-success-new"},[_c('div',{staticClass:"code-qrcode"},[_c('img',{attrs:{"src":_vm.extraItem.extras('exemResult.src'),"alt":""}})])]),(_vm.extras.successResult.text != 'hide')?_c('div',{staticClass:"t-success-new",style:({
      color:
        _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontColor
          : '',
      'font-size':
        _vm.platform != 'wap' && _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontSize + 'px'
          : '',
      'font-style':
        _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontTilt == 'on'
            ? 'italic'
            : 'normal'
          : '',
      'font-Weight':
        _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontWeight == 'on'
            ? 'bolder'
            : ''
          : '',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successResult.content"))+" ")]):_vm._e(),(_vm.extras.successResult.text2 != 'hide')?_c('div',{staticClass:"t-success-desc-new",style:({
      color:
        _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontColor2
          : '',
      'font-size':
        _vm.platform != 'wap' && _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontSize2 + 'px'
          : '',
      'font-style':
        _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontTilt2 == 'on'
            ? 'italic'
            : 'normal'
          : '',
      'font-Weight':
        _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontWeight2 == 'on'
            ? 'bolder'
            : ''
          : '',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successResult.content2"))+" ")]):_vm._e(),(_vm.platform == 'pc' && _vm.extraItem.extras('successButton.display') == 1)?_c('div',{staticClass:"u-post-new"},[_c('a-button',{staticClass:"submit",style:({
        display:
          _vm.extraItem.extras('successButton.type') == 'link' ? 'block' : 'none',
      }),attrs:{"type":"primary"},on:{"click":function($event){_vm.gotoUrl(_vm.extraItem.extras('successButton.link_link'))}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successButton.link_text"))+" ")])],1):_vm._e(),(_vm.platform == 'wap' && _vm.extraItem.extras('successButton.display') == 1)?_c('div',{staticClass:"u-post"},[_c('a-button',{staticClass:"submit",style:({
        display:
          _vm.extraItem.extras('successButton.type') == 'poster'
            ? 'block'
            : 'none',
      }),attrs:{"type":"primary","disabled":_vm.posterInfo.poster && _vm.posterInfo.poster.status != undefined},on:{"click":function($event){return _vm.goInvite()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successButton.poster_text"))+" ")]),_c('a-button',{staticClass:"submit",style:({
        display:
          _vm.extraItem.extras('successButton.type') == 'link' ? 'block' : 'none',
      }),attrs:{"type":"primary"},on:{"click":function($event){_vm.gotoUrl(_vm.extraItem.extras('successButton.link_link'))}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successButton.link_text"))+" ")])],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }